/**
 * Account Drawer - Customer authentication functionality
 */

class AccountDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-account-drawer]');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('[data-account-drawer-overlay]');
    this.loginForm = this.drawer.querySelector('[data-form-container="login"]');
    this.recoverForm = this.drawer.querySelector('[data-form-container="recover"]');
    this.panel = this.drawer.querySelector('.account-drawer__panel');

    // Initialize focus trap
    this.focusTrap = null;
    if (window.FocusTrap && this.panel) {
      this.focusTrap = new window.FocusTrap(this.panel, {
        onEscape: () => this.close()
      });
    }

    this.bindEvents();
    this.checkForRecoverHash();
  }

  bindEvents() {
    // Open account drawer
    document.querySelectorAll('[data-account-drawer-open]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close account drawer
    document.querySelectorAll('[data-account-drawer-close]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // Close on overlay click
    this.overlay?.addEventListener('click', () => this.close());

    // Close on escape key (fallback if focus trap not loaded)
    if (!this.focusTrap) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    // Form switching
    this.drawer.querySelectorAll('[data-show-form]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const formType = btn.dataset.showForm;
        this.showForm(formType);
      });
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Activate focus trap after animation
    if (this.focusTrap) {
      setTimeout(() => this.focusTrap.activate(), 300);
    } else {
      // Fallback: Focus first input after animation
      setTimeout(() => {
        const firstInput = this.drawer.querySelector('input:not([type="hidden"])');
        firstInput?.focus();
      }, 300);
    }
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Deactivate focus trap
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }

  showForm(formType) {
    if (formType === 'login' && this.loginForm && this.recoverForm) {
      this.loginForm.style.display = '';
      this.recoverForm.style.display = 'none';
    } else if (formType === 'recover' && this.loginForm && this.recoverForm) {
      this.loginForm.style.display = 'none';
      this.recoverForm.style.display = '';

      // Focus email input
      setTimeout(() => {
        const emailInput = this.recoverForm.querySelector('input[type="email"]');
        emailInput?.focus();
      }, 100);
    }
  }

  checkForRecoverHash() {
    // Check if URL has #recover hash to show recovery form
    if (window.location.hash === '#recover') {
      this.showForm('recover');
      this.open();
    }
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new AccountDrawer();
});
